import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';
import { getQueryStringValue, setQueryStringValue } from './queryString';
import { useLocation, useNavigate } from 'react-router-dom';

export function useQueryString<T extends string | string[]>(
    key: string,
    initialValue: T,
): [T, Dispatch<SetStateAction<T>>] {
    const location = useLocation();
    const navigate = useNavigate();
    const [value, setValue] = useState<T>(getQueryStringValue<T>(key, location) || initialValue);
    const onSetValue = useCallback(
        (newValue) => {
            setValue(newValue);
            navigate(setQueryStringValue(key, newValue, location));
        },
        [key, location],
    );

    useEffect(() => setValue(getQueryStringValue<T>(key, location)), [location]);

    return [value, onSetValue];
}
